import { ExpertRole, ExpertRoleName } from "@declarations/common/enums/ExpertRole";
import { GridValueFormatterParams } from "@mui/x-data-grid-pro";

const expertRoleFormatter = ({ value }: GridValueFormatterParams) => (value && ExpertRoleName[value as ExpertRole]) || value;

export default expertRoleFormatter;